import { useState } from "react";
import { toast } from "sonner";
import { logError } from "../utils/logger";

/**
 * onPropertiesChanged: optional callback invoked after a sale is confirmed,
 * so the caller can refresh the property list.
 */
export const usePendingSales = (ownerDashboardApi, onPropertiesChanged) => {
  const [pendingSales, setPendingSales] = useState([]);
  const [showConfirmSaleModal, setShowConfirmSaleModal] = useState(false);
  const [selectedSaleNotification, setSelectedSaleNotification] =
    useState(null);
  const [saleConfirmation, setSaleConfirmation] = useState({
    sale_price: "",
    notes: "",
  });

  const fetchPendingSales = async () => {
    try {
      const r = await ownerDashboardApi.getPendingSales();
      if (r.ok) setPendingSales(await r.json());
    } catch (e) {
      logError("usePendingSales.fetchPendingSales", e);
    }
  };

  const confirmSale = async () => {
    if (!selectedSaleNotification) return;
    try {
      const r = await ownerDashboardApi.confirmSale(
        selectedSaleNotification.id,
        saleConfirmation,
      );
      if (r.ok) {
        toast.success("Venta confirmada!");
        setShowConfirmSaleModal(false);
        setSelectedSaleNotification(null);
        setSaleConfirmation({ sale_price: "", notes: "" });
        fetchPendingSales();
        onPropertiesChanged?.();
      } else {
        const e = await r.json();
        toast.error(e.detail || "Error");
      }
    } catch (e) {
      toast.error("Error");
    }
  };

  const rejectSale = async (id, reason = "") => {
    try {
      const r = await ownerDashboardApi.rejectSale(id, reason);
      if (!r.ok) {
        const e = await r.json().catch(() => ({}));
        throw new Error(e.detail || "Error al rechazar");
      }
      toast.success("Notificación rechazada");
      fetchPendingSales();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return {
    pendingSales,
    showConfirmSaleModal,
    setShowConfirmSaleModal,
    selectedSaleNotification,
    setSelectedSaleNotification,
    saleConfirmation,
    setSaleConfirmation,
    fetchPendingSales,
    confirmSale,
    rejectSale,
  };
};
